export const MAX_INDENTATION_LEVEL = 6;
